import { render, staticRenderFns } from "./PacientesListado.vue?vue&type=template&id=e1a2872c"
import script from "./PacientesListado.vue?vue&type=script&lang=js"
export * from "./PacientesListado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports